<div class="main-container lg-view">
    <h3>Proposals Queue</h3>

    <div class="empty-message-container" *ngIf="!proposals?.length">There are no proposals yet!</div>

    <ul class="proposals">
        <li class="proposal" [class]="getProposalItemClass(proposal)" (click)="navigateToItemDetails(proposal)"
            *ngFor="let proposal of proposals">
            <h5 class="proposal__title">{{proposal.type}}</h5>
            <div class="proposal__body">

                <div class="proposal__info-container">
                    <span class="proposal__doc-under-review">{{proposal.documentsUnderReview}} proposal(s)</span>
                    <span class="proposal__budget" *ngIf="proposal.budget != null">(budget
                        {{proposal.budget | currency:'USD'}})</span>
                    <span
                        class="proposal__created-on">{{moment.parseZone(proposal.createdOn).format('MM/DD/YYYY')}}</span>
                </div>

                <div class="proposal__info-container align-right">
                    <span class="proposal__status">{{proposal.status}}</span>
                    <span class="proposal__updated-on" *ngIf="proposal.statusId != ProposalStatus.Pending">on
                        {{moment.parseZone(proposal.lastUpdated).format('MM/DD/YYYY')}}</span>
                    <span class="proposal__approved-budget" *ngIf="proposal.statusId == ProposalStatus.Approved">for
                        {{proposal.approvedBudget | currency:'USD'}}</span>
                    <span class="proposal__votes" *ngIf="proposal.statusId == ProposalStatus.Pending">{{proposal.votes}}
                        vote(s)</span>
                </div>

            </div>
        </li>
    </ul>


    <generic-modal #actionForbiddenModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">Add Proposal Request action is<br />disabled</h3>
        </ng-template>

        <ng-template #modalBody>
            <div style="text-align: left;">
                <h4 style="margin-top: 0;">Possible reasons:</h4>
                - No uploaded documents <br />
                - No board members
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="actionForbiddenModal.hide()">Ok</button>
        </ng-template>
    </generic-modal>
</div>

<div class="actions-container md-view">
    <ng-container *ngIf="pageType === PageType.Customer">
        <ng-container
            *ngIf="!customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
            <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
            <action-button [icon]="ButtonIcons.People" [name]="'Members'" [subpage]="'members'"></action-button>
            <action-button [icon]="ButtonIcons.AddDocument" [name]="'New\nRequest'"
                [clickAction]="onNewRequest.bind(self)">
            </action-button>
        </ng-container>

        <div class="actions-placeholder-message"
            *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
            <span
                *ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                {{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
            <span
                *ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
                {{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
            <span
                *ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
                {{ ActionsPlaceholderSettings.BothDisabled }}</span>
        </div>
    </ng-container>
    <ng-container *ngIf="pageType === PageType.BoardMember">
        <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
        <action-button
            [clickAction]="navigateWithData.bind(self, '../property-management', {returnPage: '../proposals'})"
            [icon]="ButtonIcons.People" [name]="'Property\nMgmt.'"></action-button>
    </ng-container>
</div>